import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const settlePaymentStatus = paymentId =>
  call(websocketFetch, 'set_payment_status', {
    payment_id: paymentId,
    status: 'settled',
  });
